import { PlugsConnected } from "@phosphor-icons/react";
import QuickBooksConnectCard from "../components/QuickBooksConnectCard";
import QboDigestCard from "../components/QboDigestCard";
import SamsaraConnectCard from "../components/SamsaraConnectCard";
import MotiveConnectCard from "../components/MotiveConnectCard";
import GmailConnectCard from "../components/GmailConnectCard";

/**
 * User-facing Integrations page. Owners + admins + ops managers connect
 * their own third-party services (QuickBooks, later Samsara, etc.).
 * Route: /app/integrations
 */
export default function IntegrationsPage() {
  return (
    <div className="p-4 sm:p-8 max-w-3xl" data-testid="integrations-page">
      <div className="mb-6">
        <div className="flex items-center gap-2 text-[10px] uppercase tracking-widest text-[#FF5A1F] font-semibold mb-1">
          <PlugsConnected size={12} weight="fill" /> Your account
        </div>
        <h1 className="font-display text-3xl sm:text-4xl font-semibold tracking-tight">Integrations</h1>
        <p className="text-sm text-neutral-400 mt-2 max-w-xl">
          Connect the tools your fleet already uses. FreightPilot will keep them in sync automatically —
          no CSV exports, no double entry.
        </p>
      </div>

      <div className="space-y-3">
        <GmailConnectCard />
        <QuickBooksConnectCard />
        <QboDigestCard />
        <SamsaraConnectCard />
        <MotiveConnectCard />
        {/* Future integrations (Geotab, Verizon Connect, Trimble) mount here */}
      </div>
    </div>
  );
}
